import * as React from 'react';
import * as I18n from 'i18n-js';
import URLHelpers from '../shared/url_helpers';
import SanitizedRender from '@reverbdotcom/commons/dist/components/sanitized_render';
import { CoreBumpRecommendationListingCard } from '../../schemas/rql';
import { isBrandNew, isCSPMatched } from './bump_helpers';

interface Props {
  listing: CoreBumpRecommendationListingCard.Fragment;
}

function DescriptionIsBrandNewAndMatched(props: Props) {
  const descNewWithCP = I18n.t('discovery.bumpModalV2.modal.description.promoteInPremiumSpotsBuyBox', {
    tagOpen: '<strong>',
    tagClose: '</strong>',
  });

  const buyBoxBody = I18n.t('discovery.bumpModalV2.modal.description.buyBoxRanking', {
    linkOpen: `<a class="weight-bold" href="${URLHelpers.cspPath(props.listing.csp?.slug)}" target="_blank">`,
    linkClose: '</a>',
    cspTitle: props.listing.csp?.title,
    tagOpen: '<strong>',
    tagClose: '</strong>',
  });

  return (
    <>
      <p className="mb-half">
        <SanitizedRender html={descNewWithCP} />
      </p>
      <p className="mb-half">
        <SanitizedRender html={buyBoxBody} />
      </p>
    </>
  );
}

function DescriptionIsUsedAndMatched(props: Props) {
  const descUsedWithCP = I18n.t('discovery.bumpModalV2.modal.description.promoteInPremiumSpotswCP', {
    tagOpen: '<strong>',
    tagClose: '</strong>',
    cspTitle: props.listing.csp?.title,
    linkOpen: `<a class="weight-bold" href="${URLHelpers.cspPath(props.listing.csp?.slug)}" target="_blank">`,
    linkClose: '</a>',
  });

  return (
    <>
      <p className="mb-half">
        <SanitizedRender html={descUsedWithCP} />
      </p>
      <p className="mb-half">
        {I18n.t('discovery.bumpModalV2.modal.description.additionalExposure')}
      </p>
    </>
  );
}

function DescriptionNotMatched() {
  const descNewNoCP = I18n.t('discovery.bumpModalV2.modal.description.promoteInPremiumSpots', {
    tagOpen: '<strong>',
    tagClose: '</strong>',
  });

  return (
    <>
      <p className="mb-half">
        <SanitizedRender html={descNewNoCP} />
      </p>
      <p className="mb-half">
        {I18n.t('discovery.bumpModalV2.modal.description.additionalExposure')}
      </p>
    </>
  );
}

function Description(props: Props) {
  const listingIsBrandNew = isBrandNew(props.listing.condition?.conditionSlug);
  const listingIsMatched = isCSPMatched(props.listing);

  if (listingIsMatched && listingIsBrandNew) {
    return <DescriptionIsBrandNewAndMatched listing={props.listing} />;
  }

  if (listingIsMatched && !listingIsBrandNew) {
    return <DescriptionIsUsedAndMatched listing={props.listing} />;
  }

  return <DescriptionNotMatched />;
}

export function BumpDescription(props: Props) {
  const bumpPage = URLHelpers.cmsPagePath('bump');

  return (
    <div className="size-90">
      <Description listing={props.listing} />
      <p className="mb-0">
        <SanitizedRender
          html={
            I18n.t('discovery.bumpModalV2.modal.description.payIfSells', {
              linkOpen: `<a class="icon-r-external-link" target="_blank" href="${bumpPage}">`,
              linkClose: '</a>',
            })
          }
        />
      </p>
    </div>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/bump/bump_description.tsx